<template>
    <div class="HCMegagame">
        <base-introduce :activeNav='activeNav' :IntroduceData='activeIntroduceData'></base-introduce>

        <div class="HCMegagame-main" >
          <megagame-banner :megagameName='megagameName'
            :bigBanner='bigBanner'
            :banners='banners'
            :datailPath='datailPath'>
          </megagame-banner>
        </div>

        <return-top></return-top>
    </div>
</template>

<script>
import BaseIntroduce from '@/components/active/baseIntroduce.vue'
import MegagameBanner from '@/components/active/megagameBanner.vue'
import ReturnTop from '@/components/returnTop.vue'

export default {
  name: 'HCMegagame',
  props: {

  },
  components: {
    BaseIntroduce,
    MegagameBanner,
    ReturnTop

  },
  data () {
    return {
      activeNav: '海创大赛',
      datailPath: '/HCMegagameDetail',
      activeIntroduceData: {},
      megagameName: '历届大赛',
      bigBanner: {},
      banners: []
    }
  },
  computed: {

  },
  created () {
    this.getHCMegagameData()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '4'
  },
  methods: {

    // 获取大赛数据
    async getHCMegagameData () {
      try {
        const res = await this.$get(this.$url.activity.HCMegagameData)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.activeIntroduceData = data.introduce || {}
          this.banners = data.records || []
          this.bigBanner = this.banners.shift()
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.HCMegagame{
  width: 100%;
  min-height: 50vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.HCMegagame-main{
  width: 1200px;
  min-height: 50vh;
  background-color: #fff;
  margin: 20px auto 90px;
}
</style>
